/* eslint-disable camelcase */
/* eslint-disable lines-between-class-members */
import { isProd } from 'constants/env';
import { Weblog } from '@ks/weblogger/lib/log.browser';
import Radar from '@ks/weblogger/lib/plugins/radar';
import { UrlMapFnParam } from '@ks/weblogger/lib/types/config/types';
// 自动上报 PV
// import AutoPV from '@ks/weblogger/lib/plugins/autopv';

// const urlMap = ({ url, page, params }: UrlMapFnParam) => {
//     // 域名Origin
//     let origin = page;
//     try {
//         const urlArray = url?.split('#');
//         const path = urlArray?.[1] ?? '/';
//         origin = new URL(page ?? '').origin;
//         // 将hash 映射到 path
//         page = origin + path;
//     } catch (error) {
//         console.log(error, 'error');
//     }
//     return {
//         page,
//         params,
//     };
// };
export const APP_GENERAL = 'APP_GENERAL';

const urlMap = ({ params = {} }: UrlMapFnParam) => {
    return {
        page: APP_GENERAL,
        params: {
            ...params,
            herf: window.location.href,
        },
    };
};

export const weblogger = new Weblog({
    env: 'oversea',
    plugins: [
        new Radar({
            projectId: isProd ? '0e94aa9c1n' : '1b4cc3bd3l',
            sampling: 1,
            resourceSampling: 1,
            ignoreList: ['/api/upload/fragment'],
        }),
        // new AutoPV(),
    ],
    urlMap,
});

export const logFMP = () => {
    console.log(weblogger.baseOption);
    weblogger.plugins.radar.fmp();
};

export const logCustom = async (eventType: string, params?: any) => {
    weblogger?.plugins.radar.event({
        name: `${eventType}`, // 必填
        extra_info: params ? JSON.stringify(params) : '',
    });
};

export interface ILoggerParams {
    eventType: string; // '事件类型'; // 【可选】
    category?: string; // '业务分类'; // 【可选】
    src?: string; // '事件相关源文件'; // 【可选】
    resultType?: string; // '事件结果'; // 【可选】
    message?: string; // '消息'; // 【可选】
    extraInfo?: Object | string; // '额外信息（建议使用json string）'; // 【可选】
}

const defaultNamespace = 'default';

type BaseType = string;

class RadarLogger {
    /**
     * 正常业务逻辑，用于线上问题查错使用
     * @example
     * saveCampaignLogger.log('新增广告',formData);
     */
    info(message: BaseType, extraInfo?: Object) {
        this._log('info', message, extraInfo);
    }

    /**
     * 用于debug 的信息
     */
    debug(message: BaseType, extraInfo?: Object) {
        this._log('debug', message, extraInfo);
    }

    /**
     * 错误日志，意料之外的信息
     */
    error(message: BaseType, extraInfo?: Object) {
        this._log('error', message, extraInfo);
    }

    /**
     * 关键事件开始
     * @link https://docs.corp.kuaishou.com/d/home/fcAB8GYHkqoiD7i_U4CVkzzHZ
     * @example
     *       saveCampaignLogger.start('add','新增广告开始');
     */
    start(eventName: BaseType, message: string, extraInfo?: Object) {
        this._log(`${this.defaultLoggerParams.eventType}_${eventName}`, message, extraInfo, 'start');
    }
    /**
     * 关键事件结束
     * @link https://docs.corp.kuaishou.com/d/home/fcAB8GYHkqoiD7i_U4CVkzzHZ
     * @example 
            saveCampaignLogger.end('add','新增广告完成');
     */
    end(eventName: BaseType, message: string, extraInfo?: Object) {
        this._log(`${this.defaultLoggerParams.eventType}_${eventName}`, message, extraInfo, 'end');
    }

    async _log(name: string, message: BaseType, extraInfo?: Object, type?: 'start' | 'end') {
        let logType = 'customEvent';
        if (type) {
            logType = type;
        }
        try {
            const eventParams: {
                name: string;
                event_type?: string;
                message?: string;
                extra_info?: string;
            } = {
                name, // 必填
                message,
                event_type: this.defaultLoggerParams.eventType,
            };
            // eslint-disable-next-line no-restricted-globals
            if (location.href) {
                // eslint-disable-next-line no-restricted-globals
                const url = new URL(location.href);
                const accountId = url.searchParams.get('accountId');
                if (!accountId) {
                    console.warn('accountId 不存在');
                    return;
                }
                const _extraInfo: any = {
                    accountId,
                    ...extraInfo,
                };

                try {
                    await this.cbs.beforePush?.(_extraInfo, url);
                } catch (e) {
                    console.warn(e);
                    return;
                }
                eventParams.message = String(message);
                try {
                    eventParams.extra_info = _extraInfo;
                    if (process.env.NODE_ENV === 'development') {
                        console.debug('radar 事件开始上报', _extraInfo);
                    }

                    if (logType === 'start') {
                        weblogger.plugins.radar.action.start(eventParams);
                    }
                    if (logType === 'end') {
                        weblogger.plugins.radar.action.end(eventParams);
                    }
                    if (logType === 'customEvent') {
                        weblogger.plugins.radar.event(eventParams);
                    }
                } catch (e) {
                    console.warn('radar event is error');
                    console.warn(e);
                }
            }
        } catch (e) {
            console.warn('雷达报错');
            console.warn(e);
        }
    }

    defaultLoggerParams: ILoggerParams;
    cbs: {
        // 返回true 上报，返回false 不上报
        beforePush?: (defaultExtraInfo: any, url: URL) => Promise<void>;
    };
    constructor(namespace: string, desc: string, cbs?: RadarLogger['cbs']) {
        this.cbs = {
            beforePush: cbs?.beforePush,
        };
        this.defaultLoggerParams = {
            eventType: namespace,
        };
    }
}

const loggerMap: any = {};

interface Namespace {
    key: string;
    desc: string;
}
/**
 *
 * @param namespace
 * @param cbs 打点事件回调，比如初始化一些额外信息
 * @returns {RadarLogger}
 * @example
 * export const saveCampaignLogger = getLogger('save_campaign', '计划新增/编辑日志', {
 *   async beforePush(defaultExtraInfo, url) {
 *       const [, params] = url.hash.split('?');
 *       if (params) {
 *           const hashSearchParams = new URLSearchParams(params);
 *           const campaignId = hashSearchParams.get('campaignId');
 *           defaultExtraInfo.campaignId = campaignId;
 *       }
 *   },
 *});
 */
export const getLogger = (namespace: Namespace, cbs?: RadarLogger['cbs']): RadarLogger => {
    const { key, desc } = namespace;
    if (loggerMap[key]) {
        console.error(`你的namespace已经被使用${loggerMap[key]},新的${desc}会覆盖老的，更换你的namespace`);
    } else {
        loggerMap[key] = desc;
    }
    return new RadarLogger(key || defaultNamespace, desc, cbs);
};
